import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { apiPostFormData, Create_Api } from "../../../API/Api_Url";
import { toast } from "react-toastify";
import { ArrowLeft, Upload } from "lucide-react";
import { State, City as Citie } from "country-state-city";

function ContractorSignup() {
    const navigate = useNavigate()
    const [step, setStep] = useState(1);
    const [name, setName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [SubRole, setSubRole] = useState("");
    const [Location, setLocation] = useState("");
    const [City, setCity] = useState("");
    const [gstOrCin, setGstOrCin] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [phone, setPhone] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [yearsInBusiness, setYearsInBusiness] = useState("");
    const [servicesOffered, setServicesOffered] = useState([]);
    const [geographicalAreas, setGeographicalAreas] = useState("");
    const [totalWorkers, setTotalWorkers] = useState("");
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [skills, setSkills] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);

    const handleSkillsChange = (e) => {
        const value = e.target.value;
        setSkills((prev) =>
            prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
        );
    };

    const handleServicesChange = (e) => {
        const value = e.target.value;
        setServicesOffered((prev) =>
            prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
        );
    };



    const validateStep = () => {
        if (step === 1) {
            if (!name) {
                toast.error("name is required.");
                return false;
            }
            const emailRegex = /\S+@\S+\.\S+/;
            if (!emailRegex.test(email)) {
                toast.error("Please enter a valid email address.");
                return false;
            }
            if (!password) {
                toast.error("Password is required.");
                return false;
            }
        }
        if (step === 2) {
            if (!phone && phone.length < 10) {
                toast.error("Please enter a valid phone number.");
                return false;
            }
        }
        return true;
    };


    const ContractorRole = [
        'Building Plan Approval Consultant',
        'Civil Contractor (Main)',
        'Labor Supply Contractor',
        'Aluminium / UPVC Window Vendor',
        'Ready Mix Concrete Supplier',
        'Borewell Contractor',
        'Waterproofing Specialist',
        'Scaffolding Contractor/centring',
        'False Ceiling Contractor',
        'Smart Home Automation Expert',
        'CCTV & Security System Installer',
        'Solar Panel /Green Energy Installer',
        'Generator/Inverter Vendor',
        'Signage Board',
        'Electricity Meter Sanction Expert',
        'Water Connection Approval Expert'
    ];


    const [SelectedState, setSelectedState] = useState("");
    const [SelectedDistrict, setSelectedDistrict] = useState("");

    const [Districts, setDistricts] = useState([]);
    const [Cities, setCities] = useState([]);

    useEffect(() => {
        if (SelectedState) {
            const stateCities = Citie.getCitiesOfState("IN", SelectedState);

            const uniqueDistricts = [
                ...new Set(stateCities.map((c) => c.stateCode + "-" + c.name)),
            ].map((key) => {
                const parts = key.split("-");
                return { name: parts[1], stateCode: parts[0] };
            });

            setDistricts(uniqueDistricts);
            setSelectedDistrict("");
            setCities([]);
        }
    }, [SelectedState]);

    useEffect(() => {
        if (SelectedDistrict) {
            const allCities = Citie.getCitiesOfState("IN", SelectedState);

            const filtered = allCities.filter(
                (city) => city.name === SelectedDistrict
            );

            setCities(filtered);
        }
    }, [SelectedDistrict]);

    const handleSubmit = async () => {
        const payload = {
            name,
            companyName,
            email,
            password,
            SubRole,
            Location,
            City,
            gstOrCin,
            contactPerson,
            phone,
            companyAddress,
            yearsInBusiness: Number(yearsInBusiness),
            servicesOffered,
            geographicalAreas: SelectedDistrict,
            totalWorkers: Number(totalWorkers),
            additionalNotes,
            skills
        };

        try {
            setIsUploading(true);
            const response = await Create_Api("api/contractor/register", payload);

            console.log("Register Successful:", response?.data);
            if (response?.statusCode === 200) {
                localStorage.removeItem("UserType");
                localStorage.removeItem("user");
                localStorage.removeItem("userToken");
                localStorage.setItem("UserType", "contractor");
                localStorage.setItem("user", JSON.stringify(response?.data?.contractor));
                localStorage.setItem("userToken", response?.data?.tokens?.accessToken);
                toast.success(response?.message);
                navigate("/");
                setTimeout(() => window.location.reload(), 3000);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Registration failed");
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <>
            <Navbar />
            <div className="AllSignupPadding">
                <div className="flex justify-center">
                    <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl border border-gray-200 p-10">
                        <div className="relative flex items-center mb-10">
                            <button
                                onClick={() => navigate(-1)}
                                className="absolute left-0 text-gray-700 hover:text-black transition"
                            >
                                <ArrowLeft size={26} />
                            </button>
                            <h1 className="text-3xl font-extrabold text-gray-800 text-center w-full">
                                Contractor Signup
                            </h1>
                        </div>
                        <div className="flex items-center justify-center mb-8 space-x-8">
                            {[1, 2, 3].map((num, index) => (
                                <div key={num} className="flex items-center">
                                    <div
                                        className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${step >= num
                                            ? "bg-gradient-to-r from-blue-600 to-red-500 text-white"
                                            : "bg-gray-200 text-gray-600"
                                            }`}
                                    >
                                        {num}
                                    </div>
                                    {index < 2 && (
                                        <div
                                            className={`w-16 h-1 mx-2 ${step > num
                                                ? "bg-gradient-to-r from-blue-600 to-red-500"
                                                : "bg-gray-300"
                                                }`}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>

                        <h2 className="text-2xl font-bold text-center mb-6">
                            {step === 1 && "Basic Information"}
                            {step === 2 && "Company Details"}
                            {step === 3 && "Skills & Services"}
                        </h2>

                        {step === 1 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Full Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        placeholder="Enter your full name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Company Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter company name"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
                                    <input
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Password <span className="text-red-500">*</span></label>
                                    <input
                                        type="password"
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Sub Role</label>
                                    <select
                                        value={SubRole}
                                        onChange={(e) => setSubRole(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    >
                                        <option value="">Select a role</option>
                                        {ContractorRole?.map((role, index) => (
                                            <option key={index} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Phone <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        placeholder="Enter phone number"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">
                                        GST / CIN
                                        <span className="text-gray-500 text-xs ml-1">
                                            (If you don’t have GST/CIN, leave blank.)
                                        </span>
                                    </label>

                                    <input
                                        type="text"
                                        placeholder="Enter GST or CIN"
                                        value={gstOrCin}
                                        onChange={(e) => setGstOrCin(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Contact Person</label>
                                    <input
                                        type="text"
                                        placeholder="Enter contact person"
                                        value={contactPerson}
                                        onChange={(e) => setContactPerson(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Company Address</label>
                                    <input
                                        type="text"
                                        placeholder="Enter company address"
                                        value={companyAddress}
                                        onChange={(e) => setCompanyAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Years in Business</label>
                                    <input
                                        type="number"
                                        placeholder="Enter years in business"
                                        value={yearsInBusiness}
                                        onChange={(e) => setYearsInBusiness(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Total Workers</label>
                                    <input
                                        type="number"
                                        placeholder="Enter total workers"
                                        value={totalWorkers}
                                        onChange={(e) => setTotalWorkers(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">State</label>
                                    <select
                                        value={SelectedState}
                                        onChange={(e) => setSelectedState(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select State</option>
                                        {State?.getStatesOfCountry("IN")?.map((st) => (
                                            <option key={st.isoCode} value={st?.isoCode}>
                                                {st?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">District</label>
                                    <select
                                        value={SelectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select District</option>
                                        {Districts?.map((d, idx) => (
                                            <option key={idx} value={d?.name}>
                                                {d?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">City</label>
                                    <select
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                        value={City}
                                        onChange={(e) => setCity(e.target.value)}
                                    >
                                        <option value="">Select City</option>
                                        {Cities?.map((c, idx) => (
                                            <option key={idx} value={c?.name}>
                                                {c?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Pincode</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Pincode"
                                        value={Location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div className="col-span-1 md:col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Additional Notes</label>
                                    <textarea
                                        placeholder="Enter additional notes"
                                        value={additionalNotes}
                                        onChange={(e) => setAdditionalNotes(e.target.value)}
                                        className="w-full h-24 md:h-32 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}


                        {step === 3 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Skills</label>
                                    <div className="flex flex-wrap gap-4">
                                        {["Construction Management", "Electrical", "Plumbing", "Interior Design"].map((item) => (
                                            <label key={item} className="flex items-center gap-2">
                                                <input
                                                    type="checkbox"
                                                    value={item}
                                                    checked={skills.includes(item)}
                                                    onChange={handleSkillsChange}
                                                    className="w-5 h-5 text-blue-600 border-gray-300 rounded"
                                                />
                                                {item}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <div className="col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Services Offered</label>
                                    <div className="flex flex-wrap gap-4">
                                        {["Civil Work", "Electrical Work", "Plumbing", "Interior Design"].map((item) => (
                                            <label key={item} className="flex items-center gap-2">
                                                <input
                                                    type="checkbox"
                                                    value={item}
                                                    checked={servicesOffered.includes(item)}
                                                    onChange={handleServicesChange}
                                                    className="w-5 h-5 text-blue-600 border-gray-300 rounded"
                                                />
                                                {item}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="mt-10 flex justify-between">
                            {step > 1 && (
                                <button
                                    onClick={() => setStep(step - 1)}
                                    className="px-6 py-2 rounded-full bg-gray-400 text-white hover:bg-gray-500 transition"
                                >
                                    Back
                                </button>
                            )}

                            {step < 3 ? (
                                <button
                                    onClick={() => validateStep() && setStep(step + 1)}
                                    className="ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition"
                                >
                                    Next →
                                </button>
                            ) : (
                                <button
                                    onClick={handleSubmit}
                                    disabled={IsUploading}
                                    className={`ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition flex items-center justify-center ${IsUploading ? "opacity-70 cursor-not-allowed" : ""
                                        }`}
                                >
                                    {IsUploading ? (
                                        <svg
                                            className="animate-spin h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v8H4z"
                                            ></path>
                                        </svg>
                                    ) : (
                                        "Submit ✅"
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ContractorSignup;
